import React from 'react';
import { Link } from 'react-router-dom';

import { prettyKey } from '../../helpers/formatters';

const Lease = ({ lease }) => {
  const subKey =
    ['', 'att_', 'tracfone_', 'simo_'].filter(
      (k) => lease[k + 'subscription'],
    )[0] + 'subscription';
  const subURLPrefix = subKey.replace('_', '/') + 's';

  return (
    <div>
      <h1>Lease Details</h1>
      <Link to={`/${subURLPrefix}/${lease[subKey]}/view`}>
        ← Back to subscription
      </Link>
      <table className="table">
        <tbody>
          {[
            'id',
            'att_subscription',
            'tracfone_subscription',
            'subscription',
            'user_profile',
            'user_profile_linked',
            'first_name',
            'last_name',
            'lease_type',
            'description',
            'imei',
            'product',
            'total',
            'owing',
            'paid',
            'down',
            'monthly',
            'term',
            'remain',
            'date_created',
            'buyout_type',
            'buyout_carrier',
            'buyout_cost',
            'buyout_tax',
            'buyout_term',
            'buyout_payment',
            'buyout_imei',
            'buyout_notes',
            'buyout_date',
            'buyout_details',
          ].map((attr) => (
            <tr key={attr}>
              <td>
                <strong>{prettyKey(attr)}</strong>
              </td>
              <td>
                {typeof lease[attr] !== 'undefined' &&
                  lease[attr] !== null &&
                  lease[attr].toString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {lease.buyout_purchase ? (
        <React.Fragment>
          <h4>Buyout Purchase Details</h4>
          <table className="table">
            <tbody>
              {['id', 'total', 'status', 'charge_type'].map((attr) => (
                <tr key={attr}>
                  <td>
                    <strong>{prettyKey(attr)}</strong>
                  </td>
                  <td>
                    {typeof lease.buyout_purchase[attr] !== 'undefined' &&
                      lease.buyout_purchase[attr] !== null &&
                      lease.buyout_purchase[attr].toString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </React.Fragment>
      ) : null}
    </div>
  );
};

export default Lease;
